import "./offersCard.css";
import { memo } from "react";

const buildOfferRule = (offer, offerType) => {
  const product = offer.offerProductDetails?.[0];
  if (!product) return null;

  const main = offer.mainProductName || "product";
  const offerItem = product.itemName || "item";

  switch (offerType) {
    case "buyXGetY":
      return `Buy ${product.buyQuantity || 1} ${main} and get ${product.getQuantity || 1} ${offerItem}`;
    case "offerOnMrp":
    case "buyXGetDiscount":
      return `Buy ${product.buyQuantity || 1} ${main} and get ${(product.offerDiscount || "") + (product.discountType || "")} off`;
    case "buyXGetDiscountOnY":
      return `Buy ${product.buyQuantity || 1} ${main} and get ${(product.offerDiscount || "") + (product.discountType || "")} off on ${offerItem}`;
    case "comboOfferDiscount":
      return `Buy ${main} with ${offerItem} and get ${(product.offerDiscount || "") + (product.discountType || "")} off`;
    case "stepPromotions":
      return `Buy ${product.buyQuantity || 1}+ ${main} and get ${(product.offerDiscount || "") + (product.discountType || "")} off`;
    default:
      return null;
  }
};

const formatOfferTypeLabel = (offerType) => {
  return offerType
    .replace(/_/g, " ")
    .replace(/([A-Z])/g, " $1")
    .trim()
    .replace(/\b\w/g, (c) => c.toUpperCase());
};

const OffersCard = ({ offer, index, offerType, onApply }) => {
  const offerProduct = offer.offerProductDetails?.[0];
  const offerRule = buildOfferRule(offer, offerType);
  const offerLabel = formatOfferTypeLabel(offerType);

  const cardVariantClass = index % 2 === 0 ? "ofc-card-odd" : "ofc-card-even";
  const titleSlug = offer.mainProductName
    ? offer.mainProductName.toLowerCase().replace(/[^a-z0-9]+/g, "-")
    : "offer";

  return (
    <div className={`ofc-card ${cardVariantClass}`} key={index}>
      {/* Header row */}
      <div className="ofc-header">
        <div className="ofc-header-left">
          <p className="ofc-label">Offer type</p>
          <h4
            className="ofc-title"
            data-testid={`text-offer-title-offer-${titleSlug}`}
          >
            {offerLabel}
          </h4>
        </div>
      </div>

      {/* Main / Offer product columns */}
      <div className="ofc-products">
        <div className="ofc-product-col">
          <p className="ofc-label">Main product</p>
          <p
            className="ofc-product-name"
            data-testid={`text-offer-main-product-offer-${titleSlug}`}
          >
            {offer.mainProductName || "—"}
          </p>
          {offer.mainProductMrp != null && (
            <p
              className="ofc-product-mrp"
              data-testid={`text-offer-main-mrp-offer-${titleSlug}`}
            >
              MRP ₹{offer.mainProductMrp}
            </p>
          )}
        </div>
        <div className="ofc-product-col">
          <p className="ofc-label">Offer product</p>
          <p
            className="ofc-product-name"
            data-testid={`text-offer-product-offer-${titleSlug}`}
          >
            {offerProduct?.itemName || "—"}
          </p>
        </div>
      </div>

      {/* Offer rule */}
      {offerRule && (
        <div className="ofc-rule">
          <p className="ofc-label">Offer rule</p>
          <p
            className="ofc-rule-text"
            data-testid={`text-offer-rule-offer-${titleSlug}`}
          >
            {offerRule}
          </p>
        </div>
      )}
    </div>
  );
};

export default memo(OffersCard);
